<template>
  <div class="effect">
    <div class="effect__top">
      <span style="margin-bottom: 10px;">特效</span>
      <div class="effect__item effect__item--top" :class="{'is-selected': item.selected, 'disabled': item.disabled, [`${item.classname}-wrapper`]: true}" v-for="(item, i) in topItems" :key="i" @click="setAnim(item)">
        <!-- :class="{'is-disabled': pathAnimBtnDisabled}" -->
        <div>
          <i class="is-short" :class="{[`icon-${item.name}-anim`]: true}"></i>
        </div>
        <span>{{item.text}}</span>
      </div>
    </div>
    <div class="effect__main">
      <!-- style="z-index: 1;" -->
      <div
        class="effect__gesture"
        :class="{disabled: btnHand.disabled, [currTabPanel.name]: true}"
        @click="showHandDialog($event)"
      >
        <i class="icon-hand-hand"></i>
        <span>手势</span>
      </div>

      <div class="effect__tabs tabs">
        <div class="tabs__header">
          <div class="tabs__tab" v-for="(item, i) in tabArr" :key="i"
            @click="onClickTab(i)"
            :class="{'is-active': item.active}"
          >
            {{item.text}}
          </div>
        </div>
        <div class="tabs__content" v-bar v-if="isTabsShow">
          <div>
            <transition name="fade" v-for="(item, i) in tabArr" :key="i">
              <div class="tabs__panel"
                v-show="item.active"
              >
                <div class="flex">
                  <div
                    class="effect__item"
                    :class="{['icon-wrapper-' + ( item.icon || getClassNamePart(item.type) )]: true, 'is-selected': item.selected, 'no-anim': item.type === 'noAnim', disabled: item.disabled}"
                    v-for="(item, i) in mainItems"
                    :key="i"
                    @click="selectItem(mainItems.indexOf(item), 'mainItems')"
                    :data-anim="item.type"
                    ref="effectBtnRef"
                  >
                    <i
                      class="in-out-effect-icon"
                      :class="{[`icon-effect-${item.icon || getClassNamePart(item.type)}`]: true, 'is-out': currTabPanel.name && currTabPanel.name === 'out'}"
                      style="display: block"
                    ></i>
                    <span>{{toChinese(item, tabArr.filter((tabItem) => tabItem.active)[0])}}</span>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import analysis from '@/components/mixins/analysis/spriteSettingPopup'
const noop = function () {};

export default {
  mixins: [ analysis ],
  props: {
    changeEffect: {
      type: Function,
      default: noop
    },
    // directionType: {
    //   type: String,
    //   default: 'from',
    // }
  },
  data () {
    return {
      topItems: [
        {text: '动画路径', disabled: false, type: 'pathAnim', name: 'path', classname: 'icon-path-anim', selected: false},
        {text: '旋转', disabled: false, type: 'whirl', name: 'Whirl', classname: 'icon-whirl-anim', selected: false},
        {text: '抖动', disabled: false, type: 'shake', name: 'Shake', classname: 'icon-shake-anim', selected: false}
      ],
      btnHand: {
        disabled: false,
      },
      moveMapIn: {
        noAnim: 'None',
        write: 'Write',
        hand: 'Draw',
        right: 'LeftIn',
        left: 'RightIn',
        up: 'DownIn',
        down: 'UpIn',
        pop: 'PopIn',
        fade: 'FadeIn',
        appear: 'Appear',
        type: 'Type'
      },
      moveMapOut: {
        noAnim: 'None',
        write: 'Write',
        hand: 'Draw',
        right: 'RightOut',
        left: 'LeftOut',
        up: 'UpOut',
        down: 'DownOut',
        pop: 'PopOut',
        fade: 'FadeOut'
      },
      directions: {
        to: [
          {text: '向左移', type: 'left'},
          {text: '向右移', type: 'right'},
          {text: '向上移', type: 'up'},
          {text: '向下移', type: 'down'},
        ],
        from: [
          {text: '从左移', type: 'right'},
          {text: '从右移', type: 'left'},
          {text: '从上移', type: 'down'},
          {text: '从下移', type: 'up'},
        ]
      },
      tabArr: [
        {active: true, text: '入场', name: 'in', items: [
          {text: '无动画', type: 'noAnim'},
          {text: 'pop', type: 'pop'},
          {text: 'fade', type: 'fade'},
          // {text: '手绘', type: 'hand'},
          // {text: '向左移', type: 'left'},
          // {text: '向右移', type: 'right'},
          // {text: '向上移', type: 'up'},
          // {text: '向下移', type: 'down'},
        ]},
        {active: false, text: '出场', name: 'out', items: [
          {text: '无动画', type: 'noAnim'},
          {text: 'pop', type: 'pop'},
          {text: 'fade', type: 'fade'},
        ]}
      ],
      sprite: null,
      isHandEffectDisabled: false,
      isTabsShow: false,
      // handNoneRE: /^(?:none|write|appear|type|smear|popin|popout|fadein|fadeout)$/i
      handNoneRE: /^(?:none|appear|type|smear|popin|popout|fadein|fadeout)$/i
    }
  },
  computed: {
    mainItems: {
      get () {
        return this.tabArr.filter(item => item.active)[0].items;
      },
      set (arr) {
        this.tabArr.filter(item => item.active)[0].items = arr;
      }
    },
    currTabPanel () {
      return this.tabArr.filter(item => item.active)[0];
    },
    moveMap () {
      return this.currTabPanel.name === 'in' ? this.moveMapIn : this.moveMapOut;
    },
    selectedEffect () {
      return this.mainItems.filter(item => item.selected)[0];
    },
    ...mapGetters([
      'TOOL',
      'TopNav_Size',
      'SelectScenes_Msg',
      'SelectSprites_Msg'
    ]),
    pathAnimBtnDisabled () {
      let optTarget;
      try {
        optTarget = (this.SelectSprites_Msg[0] || this.sprite).effect.pathAnim.target;
      } catch (err) { }
      return optTarget;
    }
  },
  watch: {
    'sprite.effect.pathAnim': {
      handler (val) {
        // console.log(val, '<-- sprite.effect.pathAnim')
        if (val == null) {
          return;
        }
        if (val.end) {
          this.isHandEffectDisabled = true;
          this.tabArr.filter(item => item.active)[0].items.forEach((item) => {
            if (this.isSpecialEffect(item.type)) {
              this.$set(item, 'disabled', true);
            }
          });
          // this.topItems[0].disabled = true;
          // this.$set(this.topItems[0], 'disabled', true);
        }

        this.renderTopItems();
      },
      // deep: true,
      immediate: true,
    },
    'sprite.effect.code': {
      handler (val) {
        if (val == null) {
          return;
        }
        // console.log(val, '<-- sprite.effect.code')
        if (this.hasSpecialEffect()) {
          this.toggleTopItemsDisabled(true);
        } else {
          this.toggleTopItemsDisabled(false);
        }
        // this.disablePathAnimBtn();

        if (this.handNoneRE.test('' + val) && this.currTabPanel.name === 'in') {
          this.btnHand.disabled = true;
        } else {
          this.btnHand.disabled = false;
        }

        // this.handleEntryItem(val);
      },
      immediate: true,
    },
    'sprite.effect.exitAnim.type': {
      handler (val) {
        if (val == null) {
          return;
        }

        if (this.hasSpecialEffect()) {
          this.toggleTopItemsDisabled(true);
        } else {
          this.toggleTopItemsDisabled(false);
        }

        if (this.handNoneRE.test('' + val) && this.currTabPanel.name !== 'in') {
          this.btnHand.disabled = true;
        } else {
          this.btnHand.disabled = false;
        }

        // this.handleEntryItem(val, true);
      },
      immediate: true,
    },
    'sprite.effect.stayAnim.type': {
      handler (val) {
        if (val == null) {
          return;
        }
        if (val === 'None') {
          this.isHandEffectDisabled = false;
        } else {
          this.isHandEffectDisabled = true;
        }
        this.tabArr.filter(item => item.active)[0].items.forEach((item) => {
          if (this.isSpecialEffect(item.type)) {
            this.$set(item, 'disabled', this.isHandEffectDisabled);
          }
        });

        this.renderTopItems();
      },
      immediate: true,
    },
    'currTabPanel.name': {
      handler (val) {
        if (val === 'in') {
          this.setDirections('from', this.tabArr[0]);
        } else {
          this.setDirections('to', this.tabArr[1]);
        }

        if (!this.sprite) {
          // this.btnHand.disabled = false;
          return;
        }

        let animName = this.currTabPanel.name === 'in' && this.sprite
          ? this.sprite.effect.code
          : this.sprite.effect.exitAnim.type;
        if (this.sprite && this.handNoneRE.test('' + animName)) {
          this.btnHand.disabled = true;
        } else {
          this.btnHand.disabled = false;
        }

        this.sprite && this.customEffectItems();
      },
      immediate: true
    }
  },
  created () {
    this.isTabsShow = false;
    this.sprite = this.SelectSprites_Msg[0];
    this.setDirections('from', this.currTabPanel);
    this.customEffectItems();
    this.initEffectItems();
    // this.$bus.on('updateEffect_vue', (obj) => console.log(obj, '<-- update effect bus'));
    this.$bus.on('undoRedoHandle', ({type, mod} = {}) => {
      if (type === 'updateSpriteEffect') {
        this.initEffectItems();
        this.renderTopItems();
      }
    });

    this.$bus.on('effectOptions.selectEffect', this.handleEntryItem);
  },
  mounted () {
    this.handleEntryItem();
    let {type} = this.renderTopItems();
    let isD = this.isDynamicArtText();
    if (type || isD) {
      this.toggleSpecialEffectDisabled(true);
    } else {
      this.toggleSpecialEffectDisabled(false);
    }

    this.$nextTick(() => {
      this.disableBtns();
    })
  },

  methods: {
    setDirections (directionType = 'from', tab) {
      let arr = this.getStaticItems({ noAnim: true })
        // 将这些选项取出，放到另一个弹窗
        // .concat(this.directions[directionType || this.directionType])
        .concat(this.getStaticItems())

      this.$set(tab, 'items', arr);
    },
    getStaticItems ({ noAnim = false } = {}) {
      if (noAnim) {
        return [
          {text: '无动画', type: 'noAnim'}
        ]
      }
      return [
        {text: 'slide', type: 'slide', icon: 'left'},
        {text: 'smear', type: 'smear', icon: ''},
        {text: 'pop', type: 'pop'},
        {text: 'fade', type: 'fade'},
      ]
    },
    onClickTab (index) {
      this.tabArr.forEach((item, i) => {
        if (i === index) {
          item.active = true
        } else {
          item.active = false
        }

        this.$nextTick(() => {
          this.initEffectItems();
        });
      });
    },
    selectItem (index, name) {
      const vm = this;
      // console.log({effectSetting: vm})
      let arr = this[name];
      if (/^(slide|smear)$/.test(this.mainItems[index].type)) {
        this.$parent.$parent.isShowMask = true;
        let rect = (this.$el.closest('.popups > .setting-popup') || this.$el).getBoundingClientRect();
        this.$bus.emit('FeaturesPop_vue', {
          type: 1,
          name: 'effectOptions',
          initialX: rect.left + 28,
          initialY: rect.top + 28,
          effectOptions: {
            inOut: this.currTabPanel.name,
            animation: this.mainItems[index].type,
          },
          source: this.$parent.$parent
        });

        // report
        this.$analysis(
          this.currTabPanel.name === 'in'
            ? this.ANALYSIS.effects[this.mainItems[index].type]
            : this.ANALYSIS.outEffects[this.mainItems[index].type]
        )
        return;
      }
      let btns = this.$refs.effectBtnRef || [];
      if (
        this.mainItems[index].disabled ||
        ( btns.length && btns[index].classList.contains('disabled') )
      ) {
        return;
      }
      if (
        // (this.mainItems[index].type === 'write' || this.mainItems[index].type === 'hand')
        this.isSpecialEffect(this.mainItems[index].type)
        && (this.sprite.effect.pathAnim.target || this.sprite.effect.stayAnim.type !== 'None')
      ) {
        // 弹出气泡提示
        // this.$bus.emit('showTips', {
        //   text: '路径动画和手绘动画要二选一哦。',
        //   position: {
        //     top: '100px',
        //     right: '90px'
        //   }
        // });
        return;
      }

      // this.mainItems = [...this.selectItem_(index, arr)];
      this.changeEffect_({
        // type: this.selectedEffect.type,
        // code: this.moveMap[this.selectedEffect.type],
        type: this.mainItems[index].type,
        code: this.moveMap[this.mainItems[index].type],
        inOut: this.currTabPanel.name,
        map: this.moveMap
      });
      // 弹出气泡提示
      this.$bus.emit('showTips', {
        text: '设置好入场或出场动画后，点击画布下方的“预览”可看效果哦！',
        position: {
          top: '100px',
          right: '90px'
        }
      });

      // report
      this.$analysis(
        this.currTabPanel.name === 'in'
          ? this.ANALYSIS.effects[this.mainItems[index].type]
          : this.ANALYSIS.outEffects[this.mainItems[index].type]
      )
    },
    selectItem_ (index, arr) {
      arr = arr.map((item, i) => {
        if (i === index) {
          item.selected = !item.selected;
          if (!item.selected) {
            arr[0].selected = true;
          }
        } else {
          item.selected = false;
        }
        return item
      });
      return arr;
    },
    changeEffect_ ({
      code,
      inOut, // in | out
    } = {}) {
      let inOutType;
      let sprite = this.sprite;
      if (inOut === 'in') {
        let {start, end} = sprite.effect.entranceAnim;
        if (code === 'None') {
          start = end;
        } else {
          start = Math.max(end - 500, 0);
        }
        this.sprite.updateEffect({
          code,
          entranceAnim: {
            start,
            end
          }
        }, true);
        // if (this.handNoneRE.test(sprite.effect.code)) {
        //   this.sprite.updateEffect({
        //     entranceAnim: {
        //       hand: null
        //     }
        //   });
        // }
        inOutType = 'entrance';
      }
      if (inOut === 'out') {
        let {start, end} = sprite.effect.exitAnim;
        if (code === 'None') {
          end = start;
        } else {
          if(start >= this.TOOL.selectedScenes.duration) {
            start = this.TOOL.selectedScenes.duration - 500;
          }
          end = Math.min(start + 500, this.TOOL.selectedScenes.duration);
        }
        // this.sprite.updateEffect({exitAnim: code === 'hand' ? {code: {}} : {type: code}});
        this.sprite.updateEffect({
          exitAnim: {
            type: code,
            start,
            end
          }
        }, true);
        // if (this.handNoneRE.test(sprite.effect.exitAnim.type)) {
        //   this.sprite.updateEffect({
        //     exitAnim: {
        //       hand: null
        //     }
        //   });
        // }
        inOutType = 'exit';
      }
      this.sprite.effect.init();
      this.$bus.emit('updateEffect_vue', {
        sprite: this.sprite,
        effect: this.sprite.effect || {},
        type: inOutType
      });
      this.initEffectItems();
    },
    customEffectItems () {
      let {tabArr, sprite} = this;
      let enterData = tabArr[0];
      let enterItems = enterData.items;
      let spriteType = sprite.type;
      let arr = [];
      if (spriteType === 'Text') {
        arr = [
          {text: '书写', type: 'write', disabled: this.isHandEffectDisabled},
          {text: '逐行出现', type: 'appear', disabled: this.isHandEffectDisabled},
          {text: '打字', type: 'type', disabled: this.isHandEffectDisabled},
        ];
      }

      // 是指定的svg素材，或位图素材，用户可以选择设置手绘进出场动画
      let isHand = (spriteType === 'Svg' && sprite.option && (sprite.option.fileType === 4 || sprite.option.fileType === 7 || sprite.option.fileType === 19))
        || spriteType === 'Image'

      if (isHand) {
        arr = [{text: '手绘', type: 'hand', disabled: this.isHandEffectDisabled}];
      }
      if (spriteType === 'Text' || isHand) {
        this.$set(this.tabArr[0], 'items', [...(enterItems.slice(0, 1)), ...arr, ...(enterItems.slice(1))]);
      }
      // if (isHand) {
      //   let exitItems = tabArr[1].items;
      //   let arr = [{text: '手绘', type: 'hand'}];
      //   this.$set(this.tabArr[1], 'items', [...(exitItems.slice(0, 1)), ...arr, ...(exitItems.slice(1))]);
      // }
      this.isTabsShow = true;
    },
    initEffectItems () {
      if (!this.SelectSprites_Msg) {
        return;
      }
      this.sprite = this.SelectSprites_Msg[0];
      let effect = this.sprite.effect;
      let inEff = effect.type || effect.code || 'None';
      let outEff = effect.exitAnim.type;
      let inType;
      let outType;
      for (let k in this.moveMap) {
        if (this.moveMap[k] === inEff) {
          inType = k;
          break;
        }
      }
      for (let k in this.moveMap) {
        if (this.moveMap[k] === outEff) {
          outType = k;
          break;
        }
      }
      this.setEffectItems_({
        tabData: this.currTabPanel,
        effectType: this.currTabPanel.name === 'in' ? inType : outType
      });

      this.handleEntryItem();
    },
    setEffectItems_ ({
      tabData,
      tabIndex,
      effectType
    }) {
      const vm = this;
      tabData.items.forEach((item, i) => {
        if (item.type === effectType) {
          vm.$set(item, 'selected', true);
        } else {
          vm.$set(item, 'selected', false);
        }
      })
    },
    showHandDialog (ev) {
      if (ev.currentTarget.classList.contains('disabled')) {
        return;
      }

      // 入场是否书写动画
      let modalName = this.sprite.effect.code === 'Write' ? 'writehand' : 'hand';

      this.$bus.emit('Modal_vue', {
        name: modalName, // 'writehand' : 'hand'
        type: modalName, // 'writehand' : 'hand'
        data: {
          inout: this.currTabPanel.name, // 'in' : 'out'
        }
      });

      this.$analysis(this.currTabPanel.name === 'in' ? this.ANALYSIS.gestureIn : this.ANALYSIS.gestureOut);
    },
    setPathAnim() {
      let hasPathAnim = false;
      if (this.isSpecialEffect(this.sprite.effect.code)) {
        return;
      }
      // 弹出气泡提示
      // this.$bus.emit('showTips', {
      //   text: '试试拖动其中一个素材，可调整素材运动的路线；点击“小剪刀”可取消路径动画；调整时间轴上的路径动画，可调整运动的时间。',
      //   position: {
      //     top: `${this.TopNav_Size.height + 10}px`,
      //     right: `${this.RightNav_Size.width + 20}px`
      //   }
      // })
      if(this.TOOL.selectedSprite && this.TOOL.selectedSprite.length) {
        let a = this.TOOL.selectedSprite[0];
        if (a.effect.pathAnim.target) {
          hasPathAnim = true;
        }
        let start = this.TOOL.selectedSprite[0].effect.entranceAnim.end,
            end = start + 2000;
        end > this.TOOL.selectedSprite[0].effect.exitAnim.start
          && (end = this.TOOL.selectedSprite[0].effect.exitAnim.start);
        if (end <= start) {
          end = start + 500;
        }
        // a.updateEffect({pathAnim: {start: start, end: end, target: {x: 10, y: 10, rotate: 60, w: 50, h: 100}}})
        let { positionTop: y, positionLeft: x, width: w, height: h, rotate } = a;
        a.updateEffect({
          pathAnim: hasPathAnim ? a.effect.pathAnim : {
            start: start,
            end: end,
            scale: this.TOOL.scale,
            target: {
              x: x + 200,
              y: y + 200,
              rotate,
              w: w,
              h: h
            }
          },
          stayAnim: {
            type: 'None'
          }
        }, hasPathAnim ? false : true)
        // a.effect.init();
        this.$bus.emit('updateEffect_vue', {
          sprite: this.SelectSprites_Msg[0],
          effect: this.sprite.effect || {},
          type: 'path'
        });

        this.$bus.emit('settingPopup.hideSpriteBtn');

        this.$bus.emit('FeaturesPop_close_vue', { type: 3 })

        // this.$bus.emit('FeaturesPop_vue',{
        //   name: 'pathEffectSetting',
        //   sprite: this.SelectSprites_Msg[0],
        //   type: 1
        // });

        this.$analysis({category:'material_setting_panel', action:'click_route_animation', label:'素材设置_路径动画'});
      }
    },
    setAnim(item) {
      let {type} = item;
      if (item.disabled) {
        this.$nextTick(() => {
          $('.popups > div > .mask').hide();
        })
        return;
      }
      if(type === 'pathAnim') {
        this.setPathAnim()
      }else {
        this.$bus.emit('FeaturesPop_close_vue',{type: 3});
        this.$bus.emit('FeaturesPop_vue',{
          type: type === 'whirl' ? 2 : 1,
          name: type + 'Setting',
          sprite: this.SelectSprites_Msg[0]
        });
        this.$analysis(this.ANALYSIS[type])
      }
    },
    toChinese (item, tabItem) {
      if ('pop' === item.type) {
        return tabItem.name === 'in' ? '放大出现'
          : tabItem.name === 'out' ? '缩小退出'
          : ''
      }
      if ('fade' === item.type) {
        return tabItem.name === 'in' ? '淡入'
          : tabItem.name === 'out' ? '淡出'
          : ''
      }
      if ('slide' === item.type) {
        return tabItem.name === 'in' ? '移入'
          : tabItem.name === 'out' ? '移出'
          : ''
      }
      if ('smear' === item.type) {
        return tabItem.name === 'in' ? '擦入'
          : tabItem.name === 'out' ? '擦除'
          : ''
      }
      return this.effectNameSuffix(item, tabItem);
    },
    effectNameSuffix (item, tabItem) {
      let arr = ['left', 'right', 'up', 'down'];
      if (arr.indexOf(item.type) < 0) {
        return item.text
      }
      let suffix = tabItem.name === 'in' ? '入'
        : tabItem.name === 'out' ? '出'
        : ''
      return item.text + suffix;
    },
    isDrawEffect (code) {
      return /^(?:draw|hand|write)$/i.test('' + code);
    },
    isAppearEffect (code) {
      return /^(?:appear|type)$/i.test('' + code);
    },
    isSpecialEffect (code) {
      return this.isDrawEffect(code) || this.isAppearEffect(code);
    },
    hasSpecialEffect () {
      let itemsAll = this.tabArr.reduce((memo, tab) => {
        return [...memo, ...tab.items];
      }, []);

      return itemsAll.some((item) => {
        return this.isSpecialEffect(item.type) && item.selected
      })
    },
    disableBtns () {
      let animType = this.currTabPanel.name === 'in'
        ? this.sprite.effect.code
        : this.sprite.effect.exitAnim.type;
      if (animType == null) {
        return;
      }

      if (this.isSpecialEffect(animType)) {
        this.toggleTopItemsDisabled(true);
      } else {
        this.toggleTopItemsDisabled(false);
      }
      // this.disablePathAnimBtn();

      if (this.handNoneRE.test('' + animType)) {
        this.btnHand.disabled = true;
        this.$set(this.btnHand, 'disabled', true);
      } else {
        this.btnHand.disabled = false;
        this.$set(this.btnHand, 'disabled', false);
      }
    },

    getClassNamePart (type) {
      let inOut = this.currTabPanel.name;
      let isOut = inOut === 'out';
      let effectType = isOut
        ? this.sprite.effect.exitAnim.type
        : (this.sprite.effect.type || this.sprite.effect.code);
      if (type === 'slide') {
        let map = {
          LeftIn: 'right',
          RightIn: 'left',
          UpIn: 'up',
          DownIn: 'down',
          LeftOut: 'left',
          RightOut: 'right',
          UpOut: 'up',
          DownOut: 'down'
        };
        return map[effectType] || 'left';
      }
      if (type === 'smear') {
        return 'smear-n';
      }

      return type;
    },

    /**
     * 更新进出动画图标
     */
    handleEntryItem (effectType, isOut) {
      let effObj = {};

      if (!this.$el) {
        return;
      }
      if (isOut == null) {
        let inOut = this.currTabPanel.name;
        isOut = inOut === 'out';
      }
      if (effectType == null) {
        effectType = isOut
          ? this.sprite.effect.exitAnim.type
          : (this.sprite.effect.type || this.sprite.effect.code)
      }

      effObj = isOut
        ? this.sprite.effect.exitAnim
        : this.sprite.effect;

      let anim = 'slide';
      if (/smear/i.test(effectType)) {
        anim = 'smear';
      }

      let val = effectType.replace('Smear', '');
      let elems = this.$el.querySelectorAll(`[data-anim="${anim}"]`);
      let el = isOut ? elems[1] : elems[0];
      let map = {
        LeftIn: 'right',
        RightIn: 'left',
        UpIn: 'up',
        DownIn: 'down',
        LeftOut: 'left',
        RightOut: 'right',
        UpOut: 'up',
        DownOut: 'down'
      }
      let direMap = {}
      if (anim === 'smear') {
        map = {
          LeftIn: 'right',
          RightIn: 'left',
          UpIn: 'down',
          DownIn: 'up',
          LeftOut: 'left',
          RightOut: 'right',
          UpOut: 'up',
          DownOut: 'down'
        }
        direMap = {
          n: 'smear-n',
          e: 'smear-e',
          s: 'smear-s',
          w: 'smear-w'
        }
      }
      let part = map[val];
      if (
        /^(Smear)?(Left(?:In|Out)|Right(?:In|Out)|Up(?:In|Out)|Down(?:In|Out))$/.test(val) ||
        /^Smear$/.test(effectType)
      ) {
        // console.log({classList: el.classList});

        let item = this.mainItems.filter(item => item.type === anim)[0];
        if (anim === 'smear') {
          this.$set(item, 'icon', direMap[effObj.direction]);
        } else {
          this.$set(item, 'icon', part);
        }

        this.mainItems && this.mainItems.length &&
          this.mainItems.forEach((item) => {
            if (anim === item.type) {
              this.$set(item, 'selected', true);
            } else {
              this.$set(item, 'selected', false);
            }
          })
      }
    },

    disablePathAnimBtn () {
      if (this.sprite.effect.pathAnim && this.sprite.effect.pathAnim.end) {
        this.topItems[0].disabled = true;
        this.$set(this.topItems[0], 'disabled', true);
      }
    },

    toggleTopItemsDisabled (flag) {
      this.topItems.map((item) => {
        this.$set(item, 'disabled', flag);
      });
    },
    renderTopItems () {
      let effect = this.sprite.effect;
      let effectType = '';
      if (effect.pathAnim.target) {
        effectType = 'path';
      } else {
        effectType = effect.stayAnim.type.toLowerCase();
      }
      if (effectType === 'none') {
        effectType = '';
      }
      this.topItems.map((item) => {
        this.$set(item, 'selected', false);
        if (item.name === effectType) {
          this.$set(item, 'selected', true);
        }
      });

      return {
        type: effectType
      }
    },
    toggleSpecialEffectDisabled (flag) {
      const vm = this;
      vm.isHandEffectDisabled = flag;
      let items = vm.tabArr.filter(item => item.active)[0].items;
      items.forEach((item) => {
        if (vm.isSpecialEffect(item.type)) {
          item.disabled = flag;
          vm.$set(item, 'disabled', flag);
        }
      });
      if (flag) {
        $('.icon-wrapper-write, .icon-wrapper-appear, .icon-wrapper-type, .icon-wrapper-draw')
          .addClass('disabled');
      } else {
        $('.icon-wrapper-write, .icon-wrapper-appear, .icon-wrapper-type, .icon-wrapper-draw')
          .removeClass('disabled');
      }
    },
    isDynamicArtText () {
      let sprite = this.sprite || {};
      return sprite.type === 'Text' && sprite.artType && sprite.artControl && sprite.artControl.length
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/transition";
@import "../../../style/colors";
  .effect {
    padding-left: 20px;
    padding-right: 20px;
    color: #474261;
    &__item {
      display: inline-block;
      margin-top: 16px;
      margin-right: 18px;
      text-align: center;
      cursor: pointer;

      &:nth-of-type(3n) {
        margin-right: 0;
      }
      &:nth-of-type(1), &:nth-of-type(2), &:nth-of-type(3) {
        margin-top: 0;
      }

      > .in-out-effect-icon {
        display: block;
        width: 60px;
        height: 58px;
        border: 1px solid #eff1f8;
        border-radius: 4px;
        background-color: #eff1f8;
        &.is-short {
          height: 50px;
        }
        &.is-disabled {
          opacity: 0.3;
          // background-color: red;
        }
      }
      > span {
        display: block;
        margin-top: 6px;
      }

      &.is-selected {
        > i {
          border: 1px solid $c2;
          box-shadow: 0 0 0 0.5px #5779fa;
        }
      }

      &.no-anim {
        > i {
          position: relative;
          overflow: hidden;
          &:before {
            content: " ";
            position: absolute;
            height: 1px;
            width: 110px;
            background-color: red;
            transform: rotate(-45deg) translatex(-60px) translatey(-19px);
          }
        }
      }

      &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }
    }

    &__item--top {
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 58px;
        background: #eff1f8;
        border-radius: 4px;
      }

      &.is-selected {
        & > div {
          border: 1.5px #5779fa solid;
        }
      }
    }

    &__top {
      margin-top: 34px;
      text-align: left;
      > span {
        display: block;
      }
    }

    &__main {
      position: relative;
      margin-top: 33px;
      text-align: left;

    }

    &__tabs {
      position: relative;
    }

    &__gesture {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      width: 70px;
      height: 32px;
      background-color: #d8dee9;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;
      &:hover {
        >i {
          $path: '../../../../static/svg/';
          background-image: url(#{$path}#{'hand-active.svg'});
        }
      }
      &.disabled {
        opacity: .3;
        cursor: not-allowed;
        & * {
          cursor: not-allowed !important;
        }
      }
      >i {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 0.8em;
      }
    }
    &__content {
      height: 270px;
      overflow: auto;
    }
  }

  .tabs {
    position: relative;

    &__tab {
      display: inline-block;
      width: 45px;
      line-height: 32px;
      text-align: center;
      cursor: default;
      &:first-child {
        border-radius: 4px 0 0 4px;
        border: 1px solid #d8dee9;
        border-right-width: 0;
      }
      &:last-child {
        border-radius: 0 4px 4px 0;
        border: 1px solid #d8dee9;
        border-left-width: 0;
      }

      &.is-active {
        background-color: #d8dee9;
      }
    }
    &__content {
      position: absolute;
      top: 20px;
      left: -20px;
      width: 258px;
      height: 277px;
      padding-left: 20px;
    }
    &__panel {
      position: absolute;
      top: 0;
      left: 20px;
      display: inline-block;
      width: 100%;
      padding-bottom: 20px;
      >.flex {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/content/effectSetting.vue